import React from 'react'
import { ProfileStep } from './dimmingProfile.types'
import { DaliAddressValue } from '../utils/daliAddress'

// Enveloppe optionnelle des boutons d'action (ajout/suppression de palier,
// exemple) : le consommateur y branche son explication de lecture seule
// (ex. infobulle RBAC) sans que ce module dépende de la gestion des droits.
export type ActionWrapper = React.FC<{ children: React.ReactNode }>

export const PassThroughAction: ActionWrapper = ({ children }) =>
  React.createElement(React.Fragment, null, children)

// Geometry of the SVG plotting area (excludes axis margins).
export interface EditorGeometry {
  width: number
  height: number
  marginLeft: number
  marginRight: number
  marginTop: number
  marginBottom: number
  plotWidth: number
  plotHeight: number
}

// State exposed by the presenter to the view.
export interface DimmingProfileEditorState {
  steps: ProfileStep[] // always sorted ascending by time
  activeDays: number // uint8 bitfield
  daliAddress: number // uint8 byte
  daliValue: DaliAddressValue // decoded (mode, id)
  selectedStepIndex: number | null
  draggingStepIndex: number | null
  geometry: EditorGeometry
}

// Actions the view can invoke.
export interface DimmingProfileEditorActions {
  // Step editing
  addStepAt: (timeMinutes: number, level: number) => void
  removeStep: (index: number) => void
  selectStep: (index: number | null) => void
  setStepLevel: (index: number, level: number) => void
  setStepTime: (index: number, timeMinutes: number) => void
  toggleStepInactive: (index: number) => void
  // Pointer drag lifecycle (handles)
  beginDrag: (index: number) => void
  dragTo: (clientX: number, clientY: number) => void
  endDrag: () => void
  // Click-to-add on the plot background
  handlePlotClick: (clientX: number, clientY: number) => void
  // Days
  toggleDay: (bit: number) => void
  // DALI address
  setDaliMode: (mode: DaliAddressValue['mode']) => void
  setDaliId: (id: number) => void
  // Coordinate conversions (for the view to position handles/grid)
  timeToX: (timeMinutes: number) => number
  levelToY: (level: number) => number
}
